import { render } from "./CommonHeader.vue?vue&type=template&id=7ba5e5a4&scoped=true"
const script = {}

import "./CommonHeader.vue?vue&type=style&index=0&id=7ba5e5a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba5e5a4"]])

export default __exports__